import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";

import { useSelector, useDispatch } from "react-redux";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import { CssBaseline } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import EditMeetingSpaceForm from "./EditMeetingSpaceForm";

import ConfirmationDialog from "./ConfirmationDialog";

import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import TableStatus from "./TableStatus";

const api = localStorage.getItem("api");
const theme = createMuiTheme({
  spacing: 5,
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(9)}px)`,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",

    borderRadius: "4px",
  },
}));

const MeetingSpace = ({ selectedOption, tempheader, responseData, errors, isLoading }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const emms = useSelector((state) => state.emms);
  const meetingSpaceData = useSelector((state) => state.allmeetingspaces);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const groups = useSelector((state) => state?.groups?.groups);
  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.7,
      minWidth: 120,
    },
    {
      field: "capacity",
      headerName: "Capacity",
      flex: 0.7,
      minWidth: 100,
    },

    {
      field: "location_details",
      headerName: "Location",
      flex: 1.2,
      minWidth: 200,
    },
    {
      field: "meetingspacetype",
      headerName: "Meeting Space Type",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "calendarMeetingId",
      headerName: "Calender Meeting ID",
      flex: 1.2,
      minWidth: 200,
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1.2,
      minWidth: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => handleDelete(params.row.id)}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          color="primary"
          onClick={() => handleEdit(params.row.id)}
          disabled={loading}
        >
          {loading ? "Editing..." : "Edit"}
        </Button>
      ),
    },
  ];
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);

  const handleEdit = (id) => {
    setSelectedItemId(id);
  };
  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);
    const requestBody = {
      path: "meetingspace",
      query: { id: `${deleteItemId}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then(() => {
        setRows((prevRows) => {
          const updatedRows = prevRows?.filter(
            (row) => row.id !== deleteItemId
          );
          dispatch(setMeetingSpaces(updatedRows));
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  React.useEffect(() => {
    if (meetingSpaceData.allmeetingspaces)
      setRows(meetingSpaceData.allmeetingspaces);
  }, [meetingSpaceData.allmeetingspaces]);

  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider>
            <div className="emms-data-grid-container"   style={{ padding: "2.5% 10%", overflowX: "auto" }}>
              <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                  checkboxSelection
                  disableRowSelectionOnClick
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                />
            </div>
            {selectedItemId !== null && (
              <EditMeetingSpaceForm
                meetingSpaceData={meetingSpaceData.allmeetingspaces}
                selectedOption={selectedOption}
                selectedItemId={selectedItemId}
                handleClose={() => setSelectedItemId(null)}
                groups={groups}
              />
            )}
            {showConfirmationDialog && (
              <ConfirmationDialog
                open={showConfirmationDialog}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
              />
            )}
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};

export default MeetingSpace;
